import React from 'react';
import { useAuthStore } from '../store/authStore';

interface TestFeatureGuardProps {
  children: React.ReactNode;
  /** Optional fallback to render for non-tester users (defaults to nothing) */
  fallback?: React.ReactNode;
}

/**
 * Renders children only if the current user is a tester or admin.
 * Use this to wrap experimental features that are not yet released.
 *
 * Usage:
 *   <TestFeatureGuard>
 *     <ExperimentalFeature />
 *   </TestFeatureGuard>
 */
const TestFeatureGuard: React.FC<TestFeatureGuardProps> = ({ children, fallback = null }) => {
  const isTester = useAuthStore((s: any) => s.isTester);

  if (!isTester()) return <>{fallback}</>;
  return <>{children}</>;
};

export default TestFeatureGuard;
